module.exports = __webpack_public_path__ + "img/audiojungle.d2fce497.png";